module.exports = __webpack_public_path__ + "img/GoldGoogleReview.11278f03.png";